import Phaser from 'phaser';

export function playSpellSound(scene, soundKey) {
  if (!scene.sfxManager) return;

  // Use the existing SFX manager to play spell sounds
  scene.sfxManager.playCategory(soundKey, null, {
    volumeMul: 0.8,
    rate: Phaser.Math.FloatBetween(0.9, 1.1)
  });
}